import { Component, h, Prop, Element, Host } from '@stencil/core';

/**
 * COMPNAME is a component used to a card with an image, text and CTA
 *
 * <em>For More Information:</em>
 * AEM Component- ui.apps/src/main/content/jcr_root/apps/brand/aafp/components/content/aafp-image-card
 * Sling Model- core/src/main/java/org/aafp/aem/core/models/AafpImageCard.java
 */
@Component({
  tag: 'aafp-image-card',
  shadow: false,
})
export class AafpImageCard {
  @Element() element: HTMLElement;
  /**
   * For creating the Url of image asset
   */
  @Prop() imgSrc!: string;
  /**
   * For creating the card's title
   */
  @Prop() cardTitle!: string;
  /**
   * For creating the card's text
   */
  @Prop() description!: string;
  /**
   * For adding aria label
   */
  @Prop() ariaLabel: string | null;
  /**
   * For specifying a jump target id
   */
  @Prop() jumpTargetId: string;
  /**
   * For storing the link to the CME page
   */
  @Prop() linkUrl!: string;
  /**
   * For storing the link text
   */
  @Prop() linkText!: string;
  /**
   * For storing the link aria label
   */
  @Prop() linkAriaLabel: string;

  render() {
    return (
      <Host class="adl-cme-summary-card__host" id={this.jumpTargetId}>
        <div class="adl-cme-summary-card__image">
          <img class="adl-cme-summary-card__image-asset" src={this.imgSrc} />
        </div>
        <div class="adl-cme-summary-card__content adl-image-card__content--align-left">
          <p
            class="adl-h2 adl-h2--mobile-only adl-font__light adl-cme-summary-card__content-title"
            innerHTML={this.cardTitle}
          ></p>
          <p class="adl-body adl-font__regular adl-image-card__content-description">{this.description}</p>
          <aafp-cta-button
            class="adl-cme-summary-card__content-cta"
            label={this.linkText}
            is-active="true"
            href={this.linkUrl}
            aria-label={this.linkAriaLabel ? this.linkAriaLabel : this.linkText}
            slot="cta-button"
          ></aafp-cta-button>
        </div>
      </Host>
    );
  }
}
